import { Bounds, useBounds } from "@react-three/drei";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Weather from "./components/Wheather";

const Scene = (props) => {
    const { content } = props;
    return(
      <Bounds clip observe margin={0.9}>
        <SelectToZoom>
          {
            content?.map((el, i)=> {
              const angle = (i / (content.length - 1 )) * Math.PI;
              const radius = 12;

              const x = radius * Math.cos(angle);
              const y = radius * Math.sin(angle);

              return(
                    <Weather 
                      key={el.city + "weather"}
                      position={[x, y-10, 0]}
                      rotation-y={i + 1}
                      weather={el?.weatherData?.weather[0]?.main?.toLowerCase()} 
                      name={el?.weatherData?.name}
                    />
              )
            })
          }
        </SelectToZoom>
    </Bounds>
    )
}

function SelectToZoom({ children }) {
  const api = useBounds()
  const location = useLocation();

  const handleClick = (e) => {
    e.stopPropagation();
    // console.log(e.delta)
    if (e.delta <= 2) {
      api.refresh(e.object).fit();
    }
  };

  useEffect(() => {
    if(location.pathname == "/"){
      api.refresh().fit()
    }
  }, [location]);
  

  return (
    <group 
      onClick={handleClick} 
      onPointerMissed={(e) => e.button === 0 && api.refresh().fit()}
      >
      {children}
    </group>
  )
}


export default Scene;